import { useLocation, useNavigate } from "react-router-dom";
import { Button, KIND, SIZE, SHAPE } from "baseui/button";
import { ButtonGroup } from 'baseui/button-group';
import { useEffect, useState } from "react";
import { VscBell, VscListUnordered } from "react-icons/vsc";


export const ViewSelector = () => {
    const currentLocation = useLocation();
    const [view,setView] = useState<number>(0);
    const navigate = useNavigate();
    
    useEffect(() => {
        if ( currentLocation.pathname === "/alarms")
            setView(0);
        else if ( currentLocation.pathname === "/alarms/journal")
            setView(1);
    },[currentLocation])


    return (
        <ButtonGroup kind={KIND.tertiary} size={SIZE.compact} shape={SHAPE.default}>
            <Button isSelected={view === 0} onClick={() => navigate(`/alarms/`)} ><VscBell size='1.5em' /></Button>
            <Button  isSelected={view === 1}  onClick={() => navigate(`/alarms/journal`)}><VscListUnordered size='1.5em' /></Button>
        </ButtonGroup>);
}
